import { EvidenceType } from '../../enums';

/**
 * selectionToSpans expands an array of selections made into a map
 * of partial selections by key.
 * @param selection
 * @returns
 */
const selectionToSpans = (
  selection: CMxCommonApp.ChargeSessionSelection
): CMxCommonApp.SpanActivations => {
  const { evidence, chargeSessionCode, selectionState } = selection;
  const spanActivations: CMxCommonApp.SpanActivations = {};

  const partials = evidence.filter(
    piece => piece.featureType === EvidenceType.PARTIAL
  );
  partials.forEach((piece: CMxCommonApp.ChargeSessionEvidence) => {
    const span = piece.meta as CMxAPI.Span;
    // TODO:
    // this is really dangerous and should not be done under
    // normal circumstances.  The upshot is that I do not believe MedicalCode
    // is used anywhere, and should be removed once we have gotten rid of the
    // the evidence manager.
    const code = (chargeSessionCode as any) as CMxAPI.MedicalCode;
    const codeType = `${chargeSessionCode.codeType}`.toLowerCase();

    const unstructuredSpan: CMxArtifacts.UnstructuredSpan = {
      span,
      codeType,
      code,
      active: selectionState.active
    };
    if (!Array.isArray(spanActivations[piece.fieldName])) {
      spanActivations[piece.fieldName] = [];
    }
    spanActivations[piece.fieldName].push(unstructuredSpan);
  });

  return spanActivations;
};

export { selectionToSpans };
